import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { UserRole } from '../../api/models'
import { AppStateContext } from '../../state/AppProvider'

interface AdminGuardProps {
  children: React.ReactNode
  isOnlyAdminAllowed?: boolean
}

const AdminGuard: React.FC<AdminGuardProps> = ({ children, isOnlyAdminAllowed = false }) => {
  const appStateContext = useContext(AppStateContext)

  if (!appStateContext) {
    return (
      <Navigate
        to="/"
        replace
      />
    )
  }

  const { state } = appStateContext

  if (state.isUserActive === null) {
    return null
  }

  if (!state.user && state.isUserActive === false) {
    return (
      <Navigate
        to="/"
        replace
      />
    )
  }

  if (!state.user) {
    return (
      <Navigate
        to="/"
        replace
      />
    )
  }

  const isAdmin = state.user.role === UserRole.ADMIN || state.user.role === UserRole.DECODER || state.user.role === UserRole.OU_ORCHESTRATOR

  const isOnlyAdmin = state.user.role === UserRole.ADMIN

  if (isOnlyAdminAllowed ? isOnlyAdmin : isAdmin) {
    return <>{children}</>
  }

  return (
    <Navigate
      to="/app"
      replace
    />
  )
}

export default AdminGuard
